import useNetwork from "@/stores/network";
import { PropsWithChildren } from "react";

const Online = ({ children }: PropsWithChildren) => {
  const { online } = useNetwork();
  if (!online) return null;
  return <>{children}</>;
};

export default Online;
